<template>
  <div></div>
</template>

<script>
export default {
  name: 'Home',
  created () {
    window.location.href = 'https://tb.premium-advertiser.com/gg-bg'
  },
  mounted () {
    window.location.href = 'https://tb.premium-advertiser.com/gg-bg'
  }
}
</script>





// WEBPACK FOOTER //
// src/components/LangGG/BG/LP.vue